export function formatWaitingDuration(seconds) {
    const total = Math.max(0, Math.floor(Number(seconds) || 0));
    const minutes = Math.floor(total / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (total < 3600) return `${minutes}分${total % 60}秒`;
    if (total < 86400) return `${hours}小时${minutes % 60}分`;
    if (total < 604800) return `${days}天${hours % 24}小时`;
    return `${days}天`;
}

export function getWaitingSeconds(item, now = Date.now()) {
    if (!item || item.assignmentMode !== 'SELECTED' || item.waitStatus !== 'WAITING' || !item.submittedAt) return 0;
    const raw = item.submittedAt;
    const start = raw instanceof Date ? raw.getTime() : (typeof raw === 'number' ? raw : parseWaitingTime(raw));
    if (!Number.isFinite(start)) return 0;
    return Math.max(0, Math.floor((now - start) / 1000));
}

function parseWaitingTime(value) {
    const text = String(value).trim();
    if (!text) return NaN;
    const normalized = text.replace('T', ' ').replace(/-/g, '/').replace(/\.\d{1,3}(?=Z?$)/, '');
    const parsed = new Date(normalized).getTime();
    if (Number.isFinite(parsed)) return parsed;
    return new Date(text).getTime();
}
